import { create } from 'zustand';

const useNotificationStore = create((set) => ({
  toasts: [],
  unreadCount: 0,
  friendRequestCount: 0,
  offerCount: 0,

  addToast: (message, type = 'info', duration = 3000) => {
    const id = Date.now();
    set((s) => ({ toasts: [...s.toasts, { id, message, type }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), duration);
  },

  removeToast: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),

  setUnreadCount: (count) => set({ unreadCount: count }),
  incrementUnreadCount: (count = 1) => set((s) => ({ unreadCount: s.unreadCount + count })),
  setFriendRequestCount: (count) => set({ friendRequestCount: count }),
  setOfferCount: (count) => set({ offerCount: count }),
}));

export default useNotificationStore;
